import { SecuredInvestmentIcon } from '~/@mid_ui/icons/SecuredInvestmentIcon'
import type {
  ProjectSchema,
  ProjectsItem,
} from '~/@pages_investing/projects/_project_types/project.types'
import { ProjectLabel } from './ProjectLabel'

type Props = {
  project: ProjectSchema | ProjectsItem
}

export function ProjectPopupTop({ project }: Props) {
  const originUrl = `/project/${project.businessId}/${project.stageNumber}`
  const marketValue = project.collateralInfo.propertyInfo.marketValue ?? null
  const projectTargetAmount = (project as ProjectsItem).projectTargetAmount

  return (
    <div className="flex w-full content-center justify-around px-6">
      <div className="flex flex-col self-start">
        <div className="flex flex-col">
          <a
            href={originUrl}
            className="underline text-2xl text-[#006EF0] font-semibold leading-9">
            {project.loanPurpose != null
              ? project.loanPurpose.charAt(0).toUpperCase() +
                project.loanPurpose.slice(1)
              : ''}
          </a>
          <a
            href={originUrl}
            className="underline text-sm text-[#006EF0] font-semibold leading-[21px]">
            Investičná príležitosť ID:{project.businessId}
          </a>
        </div>
        <div className="mt-2.5">
          <ProjectLabel
            subcategory={project.collateralInfo.collateralSubcategory}
            category={project.collateralInfo.collateralCategory}
          />
        </div>
      </div>
      <div className="flex flex-col">
        <div className="flex flex-col">
          <p className="text-xs font-medium leading-6 text-[#262626]">
            Trhová cena nehnuteľnosti ktorá chráni vašu investíciu je{' '}
            <strong className="text-sm font-bold leading-6">
              {marketValue?.toLocaleString('sk-SK')} EUR.
            </strong>
          </p>
          <p className="text-xs font-medium leading-6 text-[#262626]">
            Vlastník projektu má schválený maximálny úverový rámec{' '}
            <strong className="text-sm font-bold leading-6">
              {projectTargetAmount?.toLocaleString('sk-SK')} EUR.
            </strong>
          </p>
        </div>
        <div className="mt-2.5 flex items-center gap-[5px]">
          <SecuredInvestmentIcon />
          <p className="text-xs font-medium leading-5 text-[#262626]">
            Bezpečná investícia
          </p>
        </div>
      </div>
    </div>
  )
}
